module.exports = __webpack_public_path__ + "static/media/backgroundVertical.bdf8d4e0.jpg";